export const STATUS_MAP = {
  warning: { 
    classe: "toast-warning", 
    titulo: window.t ? window.t("interface.messages.attention") : "Atenção", 
    icon: "circle-exclamation", 
    colorIcon: "feedback-alert-40" 
  },
  success: { 
    classe: "toast-success", 
    titulo: window.t ? window.t("interface.messages.success") : "Sucesso", 
    icon: "check-rounded-solid", 
    colorIcon: "feedback-success-40" 
  },
  notice: { 
    classe: "toast-success", 
    titulo: window.t ? window.t("interface.messages.success") : "Sucesso", 
    icon: "check-rounded-solid", 
    colorIcon: "feedback-success-40" 
  },
  error: { 
    classe: "toast-error", 
    titulo: window.t ? window.t("interface.messages.error") : "Erro", 
    icon: "error-circle", 
    colorIcon: "feedback-error-40" 
  },
  alert: { 
    classe: "toast-error", 
    titulo: window.t ? window.t("interface.messages.error") : "Erro", 
    icon: "error-circle", 
    colorIcon: "feedback-error-40" 
  },
  info: { 
    classe: "toast-info", 
    titulo: window.t ? window.t("interface.messages.info") : "Informação", 
    icon: "circle-exclamation", 
    colorIcon: "feedback-info-40" 
  }
};

export const DEFAULT_TIMER_DURATION = 1000 * 8;
export const STATUS_WITH_AUTO_TIMER = ['success', 'notice', 'warning'];
export const CARACTERES_MAXIMOS_SHOW_AUTO_TIMER = 40;
export const TIMER_INTERVAL = 100;
export const ANIMATION_DURATION = 400;
